import barba from '@barba/core';

export default class {
    constructor() {
        // `beforeEnter`フックでもinit関数を呼び出すように修正
        barba.hooks.once((data) => {
            this.init();
            //console.log('once')
        });
        barba.hooks.beforeEnter	((data) => {
            this.init();
            //console.log('ページ遷移')
        });
    }

    init() {
        const options = {
            root: null, // Use the viewport as the root
            rootMargin: '0px',
            threshold: 0.5 // Percentage of the element that needs to be visible to trigger the callback
        };

        // Callback function when the element enters or exits the viewport
        function handleIntersection(entries, observer) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    document.getElementById('l-header').classList.add('hero--inview');
                    document.getElementById('js-drawer').classList.add('hero--inview');
                    document.getElementById('js-hamburger').classList.add('hero--inview');
                } else {
                    document.getElementById('l-header').classList.remove('hero--inview');
                    document.getElementById('js-drawer').classList.remove('hero--inview');
                    document.getElementById('js-hamburger').classList.remove('hero--inview');
                }
            });
        }

        const observer = new IntersectionObserver(handleIntersection, options);
        const heroWrapper = document.getElementById('hero--wrapper');
        observer.observe(heroWrapper);

        
    }
}

// import barba from '@barba/core';

// export default class {
//     constructor() {
//         barba.hooks.once((data) => {
//             this.init();
//             console.log('once')
//         });
//         barba.hooks.afterLeave((data) => {
//             this.init();
//             console.log('beforeEnter')
//         });
//     }

//     init() {
//         // 要素が画面内にあるかどうかを判定する関数
//         function isElementInViewport(element) {
//             let rect = element.getBoundingClientRect();
//             return (
//                 rect.bottom >= 0 &&
//                 rect.top <= (window.innerHeight || document.documentElement.clientHeight)
//             );
//         }

//         var heroWrapper = document.getElementById("hero--wrapper");
//         var isheroInView = isElementInViewport(heroWrapper);
//         var header = document.getElementById("l-header");
//         var drawer = document.getElementById("js-drawer");
//         var hamburger = document.getElementById("js-hamburger");
//         var pageElement = document.getElementById('page');
//         var namespaceValue = pageElement.getAttribute('data-barba-namespace');


//         if (namespaceValue === 'home') {
//             header.classList.add("hero--inview");
//             drawer.classList.add("hero--inview");
//             hamburger.classList.add("hero--inview");

//             console.log(heroWrapper)
//             console.log('トップ')
//             console.log(namespaceValue)
//         } else {            
//             header.classList.remove("hero--inview");
//             drawer.classList.remove("hero--inview");
//             hamburger.classList.remove("hero--inview");

//             console.log(header)
//             console.log('下層')
//             console.log(namespaceValue)
//         }

//         window.onscroll = function () {
//         var isheroInView = isElementInViewport(heroWrapper);
//             if (isheroInView) {
//                 header.classList.add("hero--inview");
//                 drawer.classList.add("hero--inview");
//                 hamburger.classList.add("hero--inview");
//                 console.log(namespaceValue)
//             } else {
//                 header.classList.remove("hero--inview");
//                 drawer.classList.remove("hero--inview");
//                 hamburger.classList.remove("hero--inview");
//                 console.log(namespaceValue)
//             }
//         };
//     }
// }